import { render, staticRenderFns } from "./FrameRegisterCallback.vue?vue&type=template&id=aceb1d12"
import script from "./FrameRegisterCallback.vue?vue&type=script&lang=js"
export * from "./FrameRegisterCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports